import React from "react";
import { Zap, Shield, Battery, Gauge, Activity } from "lucide-react";

const SignalsSection = ({ signalsData }) => {
  const getSignalConfig = (severity) => {
    const configs = {
      positive: {
        bg: "bg-emerald-50",
        border: "border-emerald-200",
        iconColor: "text-emerald-600",
        textColor: "text-emerald-700",
        barColor: "bg-emerald-500",
      },
      negative: {
        bg: "bg-red-50",
        border: "border-red-200",
        iconColor: "text-red-600",
        textColor: "text-red-700",
        barColor: "bg-red-500",
      },
      warning: {
        bg: "bg-amber-50",
        border: "border-amber-200",
        iconColor: "text-amber-600",
        textColor: "text-amber-700",
        barColor: "bg-amber-500",
      },
    };

    return configs[severity] || configs.positive;
  };

  const getSignalIcon = (signalName) => {
    const icons = {
      confidence: Zap,
      consistency: Activity,
      risk: Shield,
      fatigue: Battery,
      speedPattern: Gauge,
    };

    return icons[signalName] || Activity;
  };

  const getSignalValueWidth = (value) => {
    const widths = {
      high: "100%",
      medium: "66%",
      normal: "75%",
      low: "33%",
    };

    return widths[value] || "50%";
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      {/* Header */}
      <div className="mb-4">
        <h2 className="font-semibold text-gray-900">Performance Signals</h2>
      </div>

      {/* Signal Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        {Object.entries(signalsData).map(([key, signal]) => {
          const config = getSignalConfig(signal.severity);
          const Icon = getSignalIcon(key);
          const barWidth = getSignalValueWidth(signal.value);

          return (
            <div
              key={key}
              className={`${config.bg} ${config.border} border rounded-lg p-3`}
            >
              {/* Top Row */}
              <div className="flex items-center justify-between mb-2">
                <Icon className={`w-4 h-4 ${config.iconColor}`} />

                <span
                  className={`text-[10px] font-medium uppercase ${config.textColor}`}
                >
                  {signal.value}
                </span>
              </div>

              {/* Title */}
              <div className="text-sm font-semibold text-gray-900 capitalize truncate">
                {key}
              </div>

              {/* Description */}
              <div className="text-[11px] text-gray-600 truncate mt-0.5">
                {signal.label}
              </div>

              {/* Progress */}
              <div className="mt-2 h-1 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className={`${config.barColor} h-full rounded-full transition-all duration-500`}
                  style={{ width: barWidth }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SignalsSection;
